import React, {
  FC,
  useRef,
  useState,
  useEffect,
  Dispatch,
  SetStateAction,
  RefObject,
} from "react";
import {
  Box,
  VStack,
  HStack,
  Text,
  Button,
  Divider,
  Pressable,
  Image,
  Tooltip,
  ScrollView,
  CloseIcon,
  Spinner,
  Heading,
} from "native-base";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Offline from "react-offline";
import { useWindowDimension } from "../../../Utility/WindowDimensions";
import {
  AddIcon,
  ViewIcon,
  EditIcon,
  DeleteIcon,
  AddPhotoIcon,
  GroupChatIcon,
  MoreHorizontalIcon,
} from "../../../assets/icons/icon-assets";
import * as AV from "../../../AVCore/AVCore";
import { Loc } from "../../../App/Loc";
import { Server } from "../../../Platform/Server";
import { setEntitydata, setUser } from "../../../Redux/Actions/userActions";
import EntityProfilePic from "../../../components/common/EntityProfilePic";
import helping from "../../../assets/images/helping.png";
import inform from "../../../assets/images/inform.png";
import AVCancel from "../../../components/common/AVCancel";
import AVInputtext from "../../../components/AVInputtext";
import AVComDropdonwn from "../../../components/common/AVComDropdown";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useDropzone } from "react-dropzone";
import CustomToast from "../../../Hooks/useCustomToast";
import "driver.js/dist/driver.css";
import { driver } from "driver.js";
import AVConfirmationModal from "../../../components/common/AVConfirmationModal";
import AddGraduationClassPopup from "../../../components/common/AddGraduationClassPopup";
import { CalendarIcon } from "@mui/x-date-pickers";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import EntityEvents from "../../../components/Events/EntityEvents";
import { AVCalendarView } from "../../../components/common/calendar/AVCalendarView";

// Season:
// • Team entity → Seasons tab
// • Team Season entity → Organization tab
// • Team Season Group entity → Organization tab
// • Club entity → Terms tab
// • School entity → Alumni tab

// GradClass:
// • School entity → Grad Class tab
// • School Alumni entity → Grad Class tab
// • SchoolYear entity → Grad Class tab

// Group/(Organization):
// • Team entity → Organization tab
// • Club entity → Organization tab
// • Club Term entity → Organization tab
// • School entity → Years tab
// • Class entity → Organization tab
// • Graduation Class entity → Organization tab
// • Performance Group → Organization tab
// • Group entity → Organization tab

// Organization:
// • Elite Club entity → Organization tab
// • School entity → Teams tab
// • Organization entity → Organization tab
// • Neighborhood entity → Organization tab
// • Community entity → Organization tab

// Friends, Guardians, Dependent and Pet:
// • Person entity → Friends, Guardians, Dependent and Pet

// Events:
// • All entities → Events tab

// Resources:
// • Event entity → Resources tab

// Participants:
// • Event entity → Participants tab

// Members:
// • Team entity → Members tab
// • Team Season entity → Parents tab
// • Club entity → Members tab
// • Club Term entity → Parents tab
// • Elite Club entity → Members tab
// • School entity → Staff tab
// • School Team entity → Members tab
// • SchoolYear entity → Parents tab
// • SchoolYaer Department entity → Members tab
// • Group entity → Members tab
// • Class entity → Parents tab
// • Grad Class entity → Parents tab
// • Organization entity → Employees tab
// • Neighborhood entity → Neighbors tab
// • Community entity → Members tab
// • Performance Group entity → Members tab

// Staff:
// • Team entity → Staff tab
// • Team Season entity → Staff tab
// • Club entity → Staff tab
// • Club Term entity → Directors tab
// • Elite Club entity → Staff tab
// • School entity → Administration tab
// • School Team entity → Staff tab
// • SchoolYaer Department entity → Staff tab
// • Group entity → Staff tab
// • Class entity → Staff tab
// • Grad Class entity → Staff tab
// • Organization entity → Staff tab
// • Neighborhood entity → Staff tab
// • Community entity → Staff tab
// • Performance Group entity → Staff tab

/* ---------------------------------- Types ---------------------------------- */

type ExtendedEntity = AV.IAVEntity & {
  childOrgs?: AV.ILink[];
  subType?: string;
  season?: string;
  roles?: AV.IRole[];
  wards?: AV.ILink[];
  staff?: AV.IStaff[];
  guardians?: AV.ILink[];
  gradClasses?: AV.ILink[];
  preferences?: AV.IPreferences;
  eventType?: string;
  reoccurance?: AV.IReoccurance;
  participants?: AV.IParticipantLink[];
  sequence?: number;
  resources?: AV.IEventResource[];
  seriesEvents?: AV.ISeriesEvent[];
};

type DropdownItem = {
  id: number;
  name: string;
  flag: unknown[];
  fn: () => void;
};

type CardItem = AV.IAVEntity | AV.ILink;

type LoadingAction =
  | { type: "api"; id: string; load: boolean }
  | { type: "pic"; id: string; load: boolean }
  | { type: "chat"; id: string; load: boolean }
  | { type: "menu"; id: string; load: boolean }
  | null;

interface Props {
  tab: string;
  isAdminView: boolean;
  createConvoKey?: string;
  isCreate?: boolean;
  setIsCreate?: Dispatch<SetStateAction<boolean>>;
  entity: ExtendedEntity;
  setEntity: Dispatch<SetStateAction<AV.IAVEntity | undefined>>;
  menuRefs?: RefObject<HTMLDivElement>;
  allEventData?: any;
  eventSeriesId?: string | null | undefined;
  isLoadingEvent?: boolean;
  isCalendarView?: boolean;
  setIsCalenderView?: Dispatch<SetStateAction<boolean>>;
  isOngoingOrFuture?: boolean;
  setIsOngoingOrFuture?: Dispatch<SetStateAction<boolean>>;
  isShowEditOccurence?: boolean;
  setIsShowEditOccurence?: Dispatch<SetStateAction<boolean>>;
  isShowEditEntireSeries?: boolean;
  setIsShowEditEntireSeries?: Dispatch<SetStateAction<boolean>>;
  isEditEntireSeries?: boolean;
  setIsEditEntireSeries?: Dispatch<SetStateAction<boolean>>;
  isEntireSeriesAvailable?: boolean;
  setIsEntireSeriesAvailable?: Dispatch<SetStateAction<boolean>>;
  checkConvoExitorNot?: (type: string) => void;
  handleCreateEvent?: (type: string) => void;
  handleCreateOrg?: (type: string) => void;
  handleCreateSchoolChilds?: (type: string) => void;
  handleProfileType?: (type: string) => void;
  handleRemoveGroup?: (item: CardItem) => void;
  handleRemove?: (type: string, item: CardItem) => void;
  handleConfirmRemoveSchoolOrgs?: (type: string, item: CardItem) => void;
  handleChat?: (item: CardItem) => void;
  handleGroupChat?: (type: string) => void;
  setIsMoreMenuDrp?: Dispatch<SetStateAction<boolean>>;
  handleHomeClick?: () => void;
  onboardingFlow?: string | null;
  onboardingStep?: number;
  setOnboardingStep?: React.Dispatch<React.SetStateAction<number>>;
  clearCurrentTourFlow?: () => void;
}

/* ---------------------------------- Component ---------------------------------- */

export const AVCardList: FC<Props> = ({
  tab,
  isAdminView,
  createConvoKey,
  isCreate,
  setIsCreate,
  entity,
  setEntity,
  menuRefs,
  allEventData,
  eventSeriesId,
  isLoadingEvent,
  isCalendarView,
  setIsCalenderView,
  isOngoingOrFuture,
  setIsOngoingOrFuture,
  isShowEditOccurence,
  setIsShowEditOccurence,
  isShowEditEntireSeries,
  setIsShowEditEntireSeries,
  isEditEntireSeries,
  setIsEditEntireSeries,
  isEntireSeriesAvailable,
  setIsEntireSeriesAvailable,
  checkConvoExitorNot,
  handleCreateEvent,
  handleCreateOrg,
  handleCreateSchoolChilds,
  handleProfileType,
  handleRemoveGroup,
  handleRemove,
  handleConfirmRemoveSchoolOrgs,
  handleChat,
  handleGroupChat,
  setIsMoreMenuDrp,
  handleHomeClick,
  onboardingFlow,
  onboardingStep,
  setOnboardingStep,
  clearCurrentTourFlow,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dimensions = useWindowDimension();
  const isMobile = dimensions?.width < 600;

  const currentUser = useSelector(
    (state: RootStateOrAny) => state?.user?.user?.[0],
  );

  const entityDataList = useSelector(
    (state: RootStateOrAny) => state?.user?.entitydatalist ?? [],
  );

  const [helpText, setHelpText] = useState("");
  const [headerText, setHeaderText] = useState("");
  const [dataList, setDataList] = useState<AV.ILink[]>([]);
  const [isMoreHeaderOpen, setIsMoreHeaderOpen] = useState(false);
  const [showDeletedHuddles, setShowDeletedHuddles] = useState(false);
  const [loadingAction, setLoadingAction] = useState<LoadingAction>(null);
  const [dropdownValues, setDropdownValues] = useState<DropdownItem[]>([]);
  const [isMoreListOpen, setIsMoreListOpen] = useState<Record<string, boolean>>(
    {},
  );

  const [showAddGradClassPopup, setShowAddGradClassPopup] = useState(false);

  // Confirmation Popup
  const [isConfirm, setIsConfirm] = useState(false);
  const [confirmationText, setConfirmationText] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedItem, setSelectedItem] = useState<AV.ILink>();

  // Create Child
  const [childName, setChildName] = useState("");
  const [childDescription, setChildDescription] = useState("");
  const [showAddChildPopup, setShowAddChildPopup] = useState(false);

  // Edit Staff
  const [staffRole, setStaffRole] = useState("");
  const [staffPhone, setStaffPhone] = useState("");
  const [staffEmail, setStaffEmail] = useState("");
  const [editStaffItem, setEditStaffItem] = useState<AV.IStaff>();
  const [showEditStaffPopup, setShowEditStaffPopup] = useState(false);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // Add/Edit Resource Item
  const [resourceQty, setResourceQty] = useState("1");
  const [resourceDesc, setResourceDesc] = useState("");
  const [resourceNote, setResourceNote] = useState("");
  const [resourceAssignTo, setResourceAssignTo] = useState<AV.ILink>();
  const [resourceEditItem, setResourceEditItem] = useState<AV.IEventResource>();
  const [participantList, setParticipantList] = useState<AV.ILink[]>([]);
  const [showAddEditResourcePopup, setShowAddEditResourcePopup] =
    useState(false);

  // Participant
  const [participantStatus, setParticipantStatus] = useState("All");
  const [filteredParticipants, setFilteredParticipants] = useState<AV.ILink[]>(
    [],
  );

  const itemRef = useRef<HTMLDivElement | null>(null);
  const addUserBtnRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (
      entity?.parent?.type === "Team" &&
      entity?.type === "PlayerOrg" &&
      entity?.subType == undefined
    ) {
      return;
    }
    if (onboardingStep !== 2) return;
    if (!addUserBtnRef.current) return;

    let element: HTMLDivElement | null = null;
    let roleText = "";
    let stepTitle = "";

    switch (onboardingFlow) {
      case "teamMember":
      case "clubMember":
      case "eliteClubMember":
      case "schoolStaff":
      case "groupMember":
      case "organizationEmployee":
      case "neighborhoodNeighbors":
      case "communityMember":
        element = addUserBtnRef.current;
        roleText =
          onboardingFlow === "schoolStaff"
            ? Loc.currentLang.inviteTourGuide.staff
            : onboardingFlow === "organizationEmployee"
              ? Loc.currentLang.inviteTourGuide.employees
              : onboardingFlow === "neighborhoodNeighbors"
                ? Loc.currentLang.inviteTourGuide.neighbors
                : Loc.currentLang.inviteTourGuide.members;
        stepTitle =
          onboardingFlow === "groupMember" ||
          onboardingFlow === "organizationEmployee" ||
          onboardingFlow === "neighborhoodNeighbors" ||
          onboardingFlow === "communityMember"
            ? Loc.currentLang.inviteTourGuide.step3_2
            : Loc.currentLang.inviteTourGuide.step4_3;
        break;

      default:
        return;
    }

    if (!element) return;

    const tour = driver({
      showProgress: false,
      allowClose: true,
      overlayClickBehavior: () => {},
      showButtons: [],
      onCloseClick: () => {
        tour.destroy();
        clearCurrentTourFlow?.();
      },
      steps: [
        {
          element: element as Element,
          popover: {
            title: stepTitle,
            description: `${Loc.currentLang.inviteTourGuide.clickPlus} ${roleText}.`,
            side: "left",
            align: "center",
          },
        },
      ],
      onPopoverRender: (popover) => {
        const footer = popover.wrapper.querySelector(
          ".driver-popover-footer",
        ) as HTMLElement;
        if (!footer) return;

        footer.innerHTML = "";
        footer.style.display = "flex";
        footer.style.justifyContent = "space-between";

        const skip = document.createElement("button");
        skip.innerText = Loc.currentLang.inviteTourGuide.skip;
        skip.className = "tour-btn-secondary";
        skip.onclick = () => {
          tour.destroy();
          clearCurrentTourFlow?.();
        };

        const right = document.createElement("div");
        right.style.display = "flex";
        right.style.gap = "8px";

        const prev = document.createElement("button");
        prev.innerText = Loc.currentLang.inviteTourGuide.previous;
        prev.className = "tour-btn-secondary";
        prev.onclick = async () => {
          tour.destroy();
          if (
            onboardingFlow === "teamMember" ||
            onboardingFlow === "clubMember" ||
            onboardingFlow === "eliteClubMember" ||
            onboardingFlow === "schoolStaff"
          ) {
            await handleHomeClick?.();
            setIsMoreMenuDrp?.(true);
          }
          setOnboardingStep?.(
            onboardingFlow === "teamMember" ||
              onboardingFlow === "clubMember" ||
              onboardingFlow === "eliteClubMember" ||
              onboardingFlow === "schoolStaff"
              ? 2
              : onboardingFlow === "groupMember" ||
                  onboardingFlow === "organizationEmployee" ||
                  onboardingFlow === "neighborhoodNeighbors" ||
                  onboardingFlow === "communityMember"
                ? 1
                : 0,
          );
        };

        const next = document.createElement("button");
        next.innerText = Loc.currentLang.inviteTourGuide.next;
        next.className = "tour-btn-primary";
        next.onclick = () => {
          tour.destroy();
          handleProfileType?.(
            onboardingFlow === "teamMember" ||
              onboardingFlow === "clubMember" ||
              onboardingFlow === "eliteClubMember" ||
              onboardingFlow === "schoolStaff" ||
              onboardingFlow === "groupMember" ||
              onboardingFlow === "organizationEmployee" ||
              onboardingFlow === "neighborhoodNeighbors" ||
              onboardingFlow === "communityMember"
              ? "Member"
              : //: onboardingFlow === "player"
                //  ? "Player"
                "",
          );
          setOnboardingStep?.(
            onboardingFlow === "teamMember" ||
              onboardingFlow === "clubMember" ||
              onboardingFlow === "eliteClubMember" ||
              onboardingFlow === "schoolStaff" ||
              onboardingFlow === "groupMember" ||
              onboardingFlow === "organizationEmployee" ||
              onboardingFlow === "neighborhoodNeighbors" ||
              onboardingFlow === "communityMember"
              ? 4
              : //: onboardingFlow === "player"
                //  ? 3
                0,
          );
        };

        right.append(prev, next);
        footer.append(skip, right);
      },
    });

    setTimeout(() => tour.drive(), 100);
  }, [onboardingFlow, onboardingStep]);

  const menuRef = useRef(null);

  useOutsideAlerter(menuRef);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsMoreHeaderOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useEffect(() => {
    function handleListOutsideClick(event: MouseEvent) {
      const target = event.target as HTMLElement;

      // If click is NOT inside list menu container
      if (!target.closest('[data-list-menu="true"]')) {
        setIsMoreListOpen({});
      }
    }

    document.addEventListener("click", handleListOutsideClick);

    return () => {
      document.removeEventListener("click", handleListOutsideClick);
    };
  }, []);

  const handleCreateChild = async () => {
    try {
      setLoadingAction({ type: "api", id: entity?.id ?? "", load: true });

      if (tab === "Huddles") {
        let huddleData: ExtendedEntity = {
          type: "Channel",
          name: childName.trim(),
          parent: AV.AVEntity.getFk(entity),
          profile: { text: childDescription.trim() },
          preferences: {
            isPrivate: false,
          } as AV.IPreferences,
        };

        // Save huddle entity
        huddleData = await AV.AVEntity.save(huddleData);

        let orgLink = AV.AVEntity.getLink(huddleData);
        orgLink.title = childName.trim();
        entity?.childOrgs?.push(orgLink);

        entityDataList?.push(huddleData);
        dispatch(setEntitydata(entityDataList));

        let person = await AV.Person.getSelf(true);
        dispatch(setUser(person));

        setChildName("");
        setChildDescription("");
        setIsCreate?.(false);
        setShowAddChildPopup(false);

        setTimeout(() => {
          let HuddleData = person?.orgs?.filter(
            (x) => x?.id === (huddleData as { id?: string })?.id,
          );
          navigate(`/huddles/${HuddleData?.[0]?.id ?? 1}`, {
            state: { HuddleData: HuddleData?.[0], fromMemberTabHuddle: false },
          });
        }, 1000);
      } else {
        // Create payload
        const newEntity: ExtendedEntity = {
          season: childName,
          type: "PlayerOrg",
          name: entity?.name,
          profile: entity?.profile,
          parent: AV.AVEntity.getLink(entity),
          preferences: {
            isPrivate: false,
          } as AV.IPreferences,
        };

        // Subtype handling
        if (entity?.subType === "Club") {
          newEntity.subType = "Term";
        }

        // Save entity
        const savedEntity = await AV.AVEntity.save(newEntity);

        // Create link object
        const child = AV.AVEntity.getLink(savedEntity);
        child.title = childName;

        // Update user orgs
        if (currentUser) {
          const updatedUser = {
            ...currentUser,
            orgs: [...(currentUser.orgs || []), child],
          };
          dispatch(setUser(updatedUser));
        }

        // Update entity childOrgs
        const updatedEntity = {
          ...entity,
          childOrgs: [...(entity.childOrgs || []), child],
        };
        setEntity(updatedEntity);

        // Update Redux entity list with BOTH entries
        const updatedList = [...entityDataList];
        const index = updatedList.findIndex((x) => x?.id === entity?.id);

        if (index !== -1) {
          updatedList[index] = updatedEntity;
        } else {
          updatedList?.push(updatedEntity);
        }

        updatedList?.push(savedEntity);
        dispatch(setEntitydata(updatedList));

        // Update local UI list
        setDataList((prev) => [...(prev || []), child]);

        // Reset UI
        setChildName("");
        setShowAddChildPopup(false);
      }
    } catch (error) {
      console.error("Error creating child:", error);
    } finally {
      setLoadingAction(null);
    }
  };

  const handleConfirmToggleSilence = (item) => {
    const isSilenced = currentUser?.silenced?.some((x) => x?.id === item?.id);
    setIsConfirm(true);
    setConfirmationText(
      isSilenced
        ? Loc.currentLang.menu.areYouSurewantToUnSilence
        : Loc.currentLang.menu.areYouSurewantToSilence,
    );
    setSelectedItem(item);
    setSelectedType("ToggleSilence");
  };

  const handleToggleSilence = async () => {
    if (!selectedItem || !selectedItem.id) return;

    setIsConfirm(false);
    const itemId: string = selectedItem.id;
    setLoadingAction({ type: "menu", id: itemId, load: true });
    setIsMoreListOpen((prev) => ({
      ...prev,
      [itemId]: false,
    }));

    try {
      const isSilenced = currentUser?.silenced?.some((x) => x?.id === itemId);

      if (isSilenced) {
        await AV.AVEntity.UnSilence(
          AV.AVEntity.getFk(currentUser),
          selectedItem,
        );
      } else {
        await AV.AVEntity.silence(AV.AVEntity.getFk(currentUser), selectedItem);
      }

      const userUpdate = await AV.Person.getSelf();
      if (userUpdate?.id) {
        dispatch(setUser(userUpdate));
      }

      const updatedList = [...entityDataList];
      const index = updatedList.findIndex((x) => x?.id === userUpdate?.id);
      if (index !== -1) {
        updatedList[index] = userUpdate;
      } else {
        updatedList?.push(userUpdate);
      }

      dispatch(setEntitydata(updatedList));
    } catch (error) {
      console.error("Error while toggling silence:", error);
    } finally {
      setSelectedType("");
      setIsConfirm(false);
      setConfirmationText("");
      setSelectedItem(undefined);
      setLoadingAction(null);
    }
  };

  // GetMedia
  const getMedia = async (file?: any) => {
    let iMedia = await AV.Media.saveFiles(
      AV.Media.getFormData(file),
      entity?.region ? entity?.region : currentUser?.region,
    );

    if (!iMedia || iMedia.length === 0) return;

    // Get uploaded link
    const srclink = AV.Media.getURL(iMedia[0]);
    if (!srclink) return;

    // Set metadata before saving
    iMedia[0].parent = AV.AVBase.getFk(entity ?? currentUser);

    // Save uploaded media
    await AV.Media.saveMedia(iMedia);

    setLoadingAction(null);
    return iMedia[0];
  };

  //Edit Profile
  const {
    getRootProps: getStaffProfilePicFile,
    getInputProps: getStaffProfileInputProps,
  } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles: any) => {
      if (
        acceptedFiles?.filter((x) => x?.type.startsWith("image")) &&
        acceptedFiles?.length > 0
      ) {
        setLoadingAction({
          type: "pic",
          id: editStaffItem?.id ?? "",
          load: true,
        });
        getMedia(acceptedFiles).then((res) => {
          if (editStaffItem && res) {
            setEditStaffItem({
              ...editStaffItem,
              linkPic: res as AV.IMedia,
            });
          }
          setLoadingAction(null);
        });
      } else {
        setLoadingAction(null);
        let clientError = { message: "Invalid file type" };
        CustomToast({ clientError });
        return;
      }
    },
  });

  const handleEditStaff = async (item) => {
    if (staffEmail) {
      if (!emailRegex.test(staffEmail)) {
        let clientError = { message: Loc.currentLang.menu.inValiedEmail };
        CustomToast({ clientError });
        return;
      }
    }

    try {
      setLoadingAction({ type: "api", id: entity?.id ?? "", load: true });

      let staff: AV.IStaff = item;
      let role: AV.IRole = staff?.role;
      staff.phone = staffPhone;
      staff.email = staffEmail;
      //staff.linkPic = staffpic;
      role.name = staffRole;

      let updatedEntity = await AV.OrgBase.updateStaff(
        AV.AVEntity.getFk(entity),
        staff,
      );

      if (updatedEntity) {
        // Update Redux entity list with BOTH entries
        setEntity(updatedEntity);
        const updatedList = [...entityDataList];
        const index = updatedList.findIndex((x) => x?.id === entity?.id);

        if (index !== -1) {
          updatedList[index] = updatedEntity;
        } else {
          updatedList?.push(updatedEntity);
        }
        dispatch(setEntitydata(updatedList));
      }
    } catch (error) {
      console.error("Error editing staff:", error);
    } finally {
      setStaffPhone("");
      setStaffEmail("");
      setShowEditStaffPopup(false);
      setLoadingAction(null);
    }
  };

  const handleAddEditResource = async () => {
    try {
      setLoadingAction({ type: "api", id: entity?.id ?? "", load: true });

      let seriesId = isEditEntireSeries
        ? null
        : eventSeriesId !== "undefined" && eventSeriesId !== undefined
          ? eventSeriesId
          : null;

      let updatedEntity;

      // ADD RESOURCE
      if (!resourceEditItem) {
        const eventResources: AV.IEventResource = {
          quantity: Number(resourceQty),
          notes: resourceNote,
          resource: resourceDesc,
          resourceId: Server.generateUUID(),
          id: resourceAssignTo?.id,
          pk: resourceAssignTo?.pk,
          region: resourceAssignTo?.region,
          type: resourceAssignTo?.type,
          thumb: resourceAssignTo?.thumb,
          title: resourceAssignTo?.title,
          background: resourceAssignTo?.background,
        };

        updatedEntity = await AV.Event.addResource(
          AV.AVEntity.getFk(entity),
          eventResources,
          seriesId as any,
        );
      } else {
        // EDIT RESOURCE
        const selectedEvent = entityDataList?.find((x) => x?.id === entity?.id);

        if (
          selectedEvent &&
          (entity?.eventType === "Meeting" || entity?.eventType === "Practice")
        ) {
          const isResourcePresent = selectedEvent?.resources?.some(
            (x) => x?.id === resourceEditItem?.id,
          );

          if (isResourcePresent) {
            seriesId = null;
          }
        }

        const editValue: AV.IEventResource = {
          ...resourceEditItem,
          quantity: Number(resourceQty),
          notes: resourceNote,
          resource: resourceDesc,
          id: resourceAssignTo?.id,
          pk: resourceAssignTo?.pk,
          region: resourceAssignTo?.region,
          type: resourceAssignTo?.type,
          thumb: resourceAssignTo?.thumb,
          title: resourceAssignTo?.title,
          background: resourceAssignTo?.background,
        };

        updatedEntity = await AV.Event.updateResource(
          AV.AVEntity.getFk(entity),
          editValue,
          seriesId as any,
        );
      }

      // UPDATE REDUX ENTITY LIST
      if (updatedEntity) {
        setEntity(updatedEntity);

        const updatedList = [...entityDataList];
        const index = updatedList.findIndex((x) => x?.id === entity?.id);

        if (index !== -1) {
          updatedList[index] = updatedEntity;
        } else {
          updatedList.push(updatedEntity);
        }

        dispatch(setEntitydata(updatedList));
      }
    } catch (error) {
      console.error("Error add/edit resource item:", error);
    } finally {
      setResourceQty("1");
      setResourceDesc("");
      setResourceNote("");
      setResourceAssignTo(undefined);
      setResourceEditItem(undefined);
      setShowAddEditResourcePopup(false);
      setLoadingAction(null);
    }
  };

  const filterParticipants = (status) => {
    if (status === "ALL") {
      return dataList;
    }

    if (status === "ALL" || status === "RSVP") {
      return dataList.filter((item) => item.status == undefined);
    } else if (status === "Yes") {
      return dataList.filter((item) => item.status === "Yes");
    } else if (status === "No") {
      return dataList.filter((item) => item.status === "No");
    } else if (status === "Maybe") {
      return dataList.filter((item) => item.status === "Maybe");
    }

    return dataList;
  };

  const setAllStatus = () => {
    setParticipantStatus("All");
    const filteredParticipantsALL = filterParticipants("All");
    setFilteredParticipants(filteredParticipantsALL);
  };

  const setRsvpStatus = () => {
    setParticipantStatus("RSVP");
    const filteredParticipantRSVP = filterParticipants("RSVP");
    setFilteredParticipants(filteredParticipantRSVP);
  };

  const setYesStatus = () => {
    setParticipantStatus("Yes");
    const filteredParticipantYes = filterParticipants("Yes");
    setFilteredParticipants(filteredParticipantYes);
  };

  const setNoStatus = () => {
    setParticipantStatus("No");
    const filteredParticipantNo = filterParticipants("No");
    setFilteredParticipants(filteredParticipantNo);
  };

  const setMaybeStatus = () => {
    setParticipantStatus("Maybe");
    const filteredParticipantMayBe = filterParticipants("Maybe");
    setFilteredParticipants(filteredParticipantMayBe);
  };

  const handleItemNavigation = (item) => {
    if (!item) return;

    if (tab === "Season" || tab === "GradClass") {
      if (item.subType === "Alumni") {
        navigate(`/teams/${item.id}/${item.region}`, {
          state: { isCreate: false, team: item },
        });
      } else {
        navigate(`/season/${item.id}/${item.region}`, {
          state: { isCreate: false, team: item },
        });
      }
      return;
    }

    if (tab === "Huddles") {
      navigate(`/huddles/${item?.id}`, {
        state: {
          HuddleData: item,
          fromMemberTabHuddle: false,
        },
      });
      return;
    }

    if (
      tab === "Group" ||
      tab === "Pet" ||
      tab === "Friends" ||
      tab === "Guardians" ||
      tab === "Dependent" ||
      tab === "Members" ||
      tab === "Staff"
    ) {
      switch (item.type) {
        case "Person":
        case "Pet":
          navigate(`/profile/${item.id}/${item.region}`, {
            state: {
              user: {
                id: item.id,
                pk: item.pk,
                region: item.region,
                type: item.type,
                name: item.title,
              },
            },
          });
          return;

        case "PlayerOrg":
          navigate(`/season/${item.id}/${item.region}`, {
            state: { isCreate: false, team: item },
          });
          return;

        case "Group":
        case "SchoolYear":
          navigate(`/teams/${item.id}/${item.region}`, {
            state: { isCreate: false, team: item },
          });
          return;
      }
    }

    if (tab === "Organization") {
      if (item.type === "Person") {
        navigate(`/profile/${item.id}/${item.region}`, {
          state: {
            user: {
              id: item.id,
              pk: item.pk,
              region: item.region,
              type: item.type,
              name: item.title,
            },
          },
        });
      } else if (item.type === "PlayerOrg") {
        navigate(`/season/${item.id}/${item.region}`, {
          state: { isCreate: false, team: item },
        });
      } else if (item.type === "Group" || item.type === "Team") {
        navigate(`/teams/${item.id}/${item.region}`, {
          state: { isCreate: false, team: item },
        });
      } else {
        navigate(`/teams/${item.id}/${item.region}`, {
          state: { isCreate: false, team: item },
        });
      }

      return;
    }

    navigate(`/organizations/${item.id}/${item.region}/${item.type}`, {
      state: {
        isCreate: false,
        orgType: item.type,
        org: item,
      },
    });
  };

  const getHeaderText = () => {
    switch (tab) {
      case "Season":
        return entity?.subType === "Club"
          ? Loc.currentLang.menu.terms
          : entity?.type === "School"
            ? Loc.currentLang.menu.alumni
            : entity?.type === "PlayerOrg"
              ? Loc.currentLang.menu.organization
              : Loc.currentLang.menu.seasons;

      case "GradClass":
        return Loc.currentLang.menu.gradClass;

      case "Group":
        return entity?.type === "School"
          ? Loc.currentLang.menu.years
          : Loc.currentLang.menu.organization;

      case "Organization":
        return entity?.type === "Club" || entity?.type === "School"
          ? Loc.currentLang.menu.teams
          : Loc.currentLang.menu.organization;

      case "Pet":
        return Loc.currentLang.menu.pet;

      case "Friends":
        return Loc.currentLang.menu.friends;

      case "Guardians":
        return Loc.currentLang.menu.guardians;

      case "Dependent":
        return Loc.currentLang.menu.dependents;

      case "Huddles":
        return Loc.currentLang.menu.huddless;

      case "Events":
        return Loc.currentLang.menu.events;

      case "Resources":
        return Loc.currentLang.menu.resources;

      case "Participants":
        return Loc.currentLang.menu.participants;

      case "Members":
        return entity?.type === "School"
          ? Loc.currentLang.menu.staff
          : (entity?.type === "PlayerOrg" ||
                entity?.subType === "Class" ||
                entity?.subType === "GradClass") &&
              entity?.subType !== "MusicGroup"
            ? Loc.currentLang.menu.parents
            : entity?.type === "Neighborhood"
              ? Loc.currentLang.menu.neighbors
              : entity?.type === "Organization"
                ? Loc.currentLang.menu.employees
                : entity?.type === "PlayerOrg" &&
                    entity?.subType === "MusicGroup"
                  ? Loc.currentLang.menu.members
                  : entity?.type === "SchoolYear"
                    ? Loc.currentLang.menu.parents
                    : Loc.currentLang.menu.members;

      case "Staff":
        return entity?.type === "School"
          ? Loc.currentLang.menu.administration
          : entity?.subType == "Term"
            ? Loc.currentLang.menu.directors
            : Loc.currentLang.menu.staff;

      default:
        return "";
    }
  };

  const getHelpText = () => {
    switch (tab) {
      case "Season":
        return entity?.subType === "Club"
          ? Loc.currentLang.helpText.club.termTab
          : entity?.type === "Team"
            ? Loc.currentLang.helpText.team.seasonTab
            : entity?.type === "PlayerOrg"
              ? Loc.currentLang.helpText.season.subTeamTab
              : "";

      case "GradClass":
        return Loc.currentLang.helpText.school.gradClassTab;

      case "Group":
        if (entity?.type === "Team" && entity?.subType === "Club") {
          return Loc.currentLang.helpText.club.groupTab;
        }
        if (entity?.type === "PlayerOrg" && entity?.subType === "Term") {
          return Loc.currentLang.helpText.term.groupTab;
        }
        if (
          entity?.type === "Group" ||
          (entity?.type === "PlayerOrg" && entity?.subType === "Class")
        ) {
          return Loc.currentLang.helpText.group.groupTab;
        }
        if (entity?.type === "PlayerOrg" && entity?.subType === "GradClass") {
          return Loc.currentLang.helpText.gradClass.groupTab;
        }
        if (entity?.type === "PlayerOrg" && entity?.subType === "MusicGroup") {
          return Loc.currentLang.helpText.person.organizationTxt;
        }
        if (entity?.type === "School") {
          return Loc.currentLang.helpText.school.yearsTab;
        }
        //if (entity?.type === "Group") {
        //  return Loc.currentLang.helpText.group.groupTab;
        //}

        return Loc.currentLang.helpText.team.groupTab;

      case "Organization":
        if (entity?.type === "Club") {
          return Loc.currentLang.helpText.eliteClub.teamsTab;
        }
        if (entity?.type === "Team") {
          return Loc.currentLang.helpText.team.groupTab;
        }
        if (entity?.type === "School") {
          return Loc.currentLang.helpText.school.teamsTab;
        }
        if (entity?.type === "Organization") {
          return Loc.currentLang.helpText.organization.organizationTab;
        }
        if (entity?.type === "Neighborhood") {
          return Loc.currentLang.helpText.neighborHood.organizationTab;
        }
        if (entity?.type === "Community") {
          return Loc.currentLang.helpText.community.organizationTab;
        }

        return Loc.currentLang.menu.organization;

      case "Pet":
        return Loc.currentLang.helpText.person.petTab;

      case "Friends":
        return Loc.currentLang.helpText.person.friendTab;

      case "Guardians":
        return Loc.currentLang.helpText.person.guardianTab;

      case "Dependent":
        return Loc.currentLang.helpText.person.dependentTab;

      case "Huddles":
        return Loc.currentLang.huddles.helpText;

      case "Events":
        return Loc.currentLang.helpText.person.eventTab;

      case "Resources":
        return Loc.currentLang.helpText.event.resourcesTab;

      case "Participants":
        return Loc.currentLang.helpText.event.participantTab;

      case "Members":
        if (entity?.type === "Team") {
          return Loc.currentLang.helpText.team.memberTab;
        }
        if (
          (entity?.parent?.type === "Team" ||
            entity?.parent?.type === "PlayerOrg") &&
          entity?.type === "PlayerOrg" &&
          entity?.subType == undefined
        ) {
          return Loc.currentLang.helpText.season.parentTab;
        }
        if (entity?.type === "Team" && entity?.subType == "Club") {
          return Loc.currentLang.helpText.club.memberTab;
        }
        if (entity?.type === "PlayerOrg" && entity?.subType === "Term") {
          return Loc.currentLang.helpText.term.parentTab;
        }
        if (entity?.type === "Club") {
          return Loc.currentLang.helpText.eliteClub.memberTab;
        }
        if (entity?.type === "School") {
          return Loc.currentLang.helpText.school.staffTab;
        }
        if (entity?.type === "SchoolYear") {
          return Loc.currentLang.helpText.class.parentTab;
        }
        if (entity?.type === "Group") {
          return Loc.currentLang.helpText.group.memberTab;
        }
        if (
          entity?.type === "PlayerOrg" &&
          (entity?.subType == "Class" || entity?.subType == "GradClass")
        ) {
          return Loc.currentLang.helpText.class.parentTab;
        }
        if (entity?.type === "PlayerOrg" && entity?.subType == "MusicGroup") {
          return Loc.currentLang.helpText.club.memberTab;
        }
        if (entity?.type === "Organization") {
          return Loc.currentLang.helpText.organization.memberTab;
        }
        if (entity?.type === "Neighborhood") {
          return Loc.currentLang.helpText.neighborHood.neighborTab;
        }
        if (entity?.type === "Community") {
          return Loc.currentLang.helpText.community.memberTab;
        }

        return Loc.currentLang.menu.organization;

      case "Staff":
        if (entity?.type === "Team" && entity?.subType == undefined) {
          return Loc.currentLang.helpText.team.staffTab;
        }
        if (
          entity?.parent?.type === "Team" &&
          entity?.type === "PlayerOrg" &&
          entity?.subType == undefined
        ) {
          return Loc.currentLang.helpText.season.staffTab;
        }
        if (entity?.type === "Team" && entity?.subType == "Club") {
          return Loc.currentLang.helpText.club.staffTab;
        }
        if (entity?.type === "PlayerOrg" && entity?.subType === "Term") {
          return Loc.currentLang.helpText.term.directorTab;
        }
        if (entity?.type === "Club") {
          return Loc.currentLang.helpText.eliteClub.staffTab;
        }
        if (entity?.type === "School") {
          return Loc.currentLang.helpText.school.administrationTab;
        }
        if (entity?.type === "SchoolYear") {
          return Loc.currentLang.helpText.class.staffTab;
        }
        if (entity?.type === "Group") {
          return Loc.currentLang.helpText.group.staffTab;
        }
        if (
          entity?.type === "PlayerOrg" &&
          (entity?.subType == "Class" || entity?.subType == "GradClass")
        ) {
          return Loc.currentLang.helpText.class.staffTab;
        }
        if (entity?.type === "PlayerOrg" && entity?.subType == "MusicGroup") {
          return Loc.currentLang.helpText.club.staffTab;
        }
        if (entity?.type === "Organization") {
          return Loc.currentLang.helpText.organization.staffTab;
        }
        if (entity?.type === "Neighborhood") {
          return Loc.currentLang.helpText.neighborHood.administrationTab;
        }
        if (entity?.type === "Community") {
          return Loc.currentLang.helpText.community.staffTab;
        }

        return Loc.currentLang.menu.organization;

      default:
        return "";
    }
  };

  const getParticipants = () => {
    if (!entity) return [];

    let participants;

    if (eventSeriesId && eventSeriesId.trim().length > 0) {
      if (entity?.seriesEvents && entity?.seriesEvents?.length > 0) {
        const entireParticipants = entity?.participants || [];
        const occParticipants =
          entity?.seriesEvents?.find((x) => x?.id === eventSeriesId)
            ?.participants || [];
        const occParticipantIds = occParticipants
          .map((p) => p?.id)
          .filter(Boolean);

        // Combine occParticipants and unique participants from entireParticipants
        const uniqueEntireParticipants = entireParticipants.filter(
          (p) => !occParticipantIds.includes(p?.id),
        );

        // Final participant list: occParticipants first, then unique ones from entire
        const finalParticipants = [
          ...occParticipants,
          ...uniqueEntireParticipants,
        ];

        // Set the cleaned participant list
        participants = finalParticipants;

        //// Find common IDs
        //const sameIds = entireParticipants
        //  .map((p) => p?.id)
        //  .filter((id) => id && occParticipants.some((op) => op?.id === id));

        // if (sameIds.length > 0) {
        //  // Get same participants from both arrays
        //  const sameFromEntire = entireParticipants.filter((p) =>
        //    sameIds.includes(p.id)
        //  );
        //  const sameFromOcc = occParticipants.filter((p) => sameIds.includes(p.id));

        //  // Combine and dedupe by id, keeping latest statusDate
        //  const sameParticipantsCombined = [...sameFromEntire, ...sameFromOcc];

        //  // Sort first by statusDate DESC (latest first), then uniqBy id
        //  const sameParticipants = _.uniqBy(
        //    sameParticipantsCombined.sort(
        //      (a, b) =>
        //        new Date(b.statusDate).getTime() - new Date(a.statusDate).getTime()
        //    ),
        //    "id"
        //  );

        //  // Diff participants (only from entireParticipants not present in occParticipants)
        //  const diffParticipants = entireParticipants.filter(
        //    (p) => p?.id && !occParticipantIds.includes(p.id)
        //  );

        //  // Final participants list
        //  participants = [...sameParticipants, ...diffParticipants];
        //} else {
        //     participants = [...entireParticipants, ...occParticipants];
        //}
      } else {
        participants = entity?.participants || [];
      }
    } else {
      participants = entity?.participants;
    }

    // To sort the array so that items with linkType === 'Owner' or linkType === 'Staff' come first
    participants = participants?.sort((a, b) => {
      const getRank = (type) => {
        if (type === "Owner") return 0;
        if (type === "Staff") return 1;
        return 2; // for Participant or any other
      };
      return getRank(a.linkType) - getRank(b.linkType);
    });

    return participants ?? [];
  };

  const getDataList = (showDeleted = showDeletedHuddles): AV.ILink[] => {
    if (!entity) return [];

    if (tab === "Pet") {
      return entity.wards?.filter((x) => x?.type === "Pet") ?? [];
    }

    if (tab === "Friends") {
      return entity.members ?? [];
    }

    if (tab === "Guardians") {
      return entity.guardians ?? [];
    }

    if (tab === "Dependent") {
      return entity.wards?.filter((x) => x?.type === "Person") ?? [];
    }

    if (tab === "Huddles") {
      if (currentUser?.orgs && entity?.childOrgs) {
        // Get all channel IDs from childOrgs
        const childChannelIds = entity.childOrgs
          .filter((org) => org.type === "Channel")
          .map((org) => org.id);

        // Find deleted channels in currentUser.orgs
        const deleted = currentUser.orgs.filter(
          (org) =>
            org.type === "Channel" &&
            org.status === "Deleted" &&
            childChannelIds.includes(org.id),
        );

        // Find NOT deleted channels
        const notDeleted = currentUser.orgs.filter(
          (org) =>
            org.type === "Channel" &&
            org.status !== "Deleted" &&
            childChannelIds.includes(org.id),
        );

        // Both deleted and not deleted
        const allChennels = currentUser.orgs.filter(
          (org) => org.type === "Channel" && childChannelIds.includes(org.id),
        );

        return showDeleted ? (deleted ?? []) : (notDeleted ?? []);
      }
    }

    if (tab === "Resources") {
      let resources;
      if (eventSeriesId && eventSeriesId.trim().length > 0) {
        let allResource =
          entity?.seriesEvents?.filter((x) => x?.id === eventSeriesId) ?? [];
        if (allResource?.length > 0) {
          resources = [
            ...(entity?.resources ?? []),
            ...(allResource[0]?.resources ?? []),
          ];
        } else {
          resources = entity?.resources;
        }
      } else {
        resources = entity?.resources;
      }

      const participants = getParticipants();
      setParticipantList(participants ?? []);

      return resources ?? [];
    }

    if (tab === "Participants") {
      const participants = getParticipants();
      setFilteredParticipants(participants ?? []);
      return participants ?? [];
    }

    if (tab === "Members") {
      return entity.members ?? [];
    }

    if (tab === "Staff") {
      return entity.staff ?? [];
    }

    if (!entity.childOrgs) return [];

    switch (tab) {
      case "Season":
        return entity.type === "School"
          ? entity.childOrgs.filter((x) => x?.subType === "Alumni")
          : entity.childOrgs.filter(
              (x) =>
                x?.type !== "Group" &&
                x?.type !== "Channel" &&
                x?.type !== "Collect",
            );

      case "GradClass":
        return entity.type === "School"
          ? entity.childOrgs.filter((x) => x?.type === "PlayerOrg")
          : entity.type === "SchoolYear"
            ? (entity.gradClasses ?? [])
            : entity.childOrgs.filter((x) => x.type === "PlayerOrg");

      case "Group":
        return entity.type === "School"
          ? entity.childOrgs.filter((x) => x?.type === "SchoolYear")
          : entity.childOrgs.filter((x) => x?.type === "Group");

      case "Organization":
        return entity.type === "School"
          ? entity.childOrgs?.filter(
              (x) =>
                (x.type === "Team" ||
                  x.type === "Club" ||
                  x.type === "Group") &&
                x.subType !== "Alumni",
            )
          : entity.childOrgs.filter(
              (x) =>
                x?.type !== "Channel" &&
                x?.type !== "Collect" &&
                x?.subType !== "Alumni",
            );

      default:
        return [];
    }
  };

  const createOption = (
    id: number,
    name: string,
    type: string,
    fnHandler?: (type: string) => void,
  ): DropdownItem => ({
    id,
    name,
    flag: [],
    fn: () => fnHandler?.(type),
  });

  const createEventOption = (
    id: number,
    name: string,
    type: string,
  ): DropdownItem => ({
    id,
    name,
    flag: allEventData,
    fn: () => handleCreateEvent?.(type),
  });

  const getDropdownValues = (): DropdownItem[] => {
    if (!isAdminView) return [];

    if (tab === "Group") {
      if (entity?.subType !== "GradClass") return [];

      return [
        createOption(1, Loc.currentLang.menu.group, "Group", handleCreateOrg),
        ...(entity.subType === "GradClass" || entity.subType === "Term"
          ? [
              createOption(
                2,
                Loc.currentLang.menu.team,
                "Team",
                handleCreateOrg,
              ),
            ]
          : []),
        ...(entity.subType === "GradClass"
          ? [
              createOption(
                3,
                Loc.currentLang.menu.club,
                "Club",
                handleCreateOrg,
              ),
            ]
          : []),
      ];
    }

    if (tab === "Organization") {
      const isOrgType = [
        "Organization",
        "Community",
        "School",
        "Club",
        "Neighborhood",
      ].includes(entity?.type ?? "");

      if (entity?.type === "SchoolYear") {
        return [
          createOption(
            1,
            Loc.currentLang.menu.department,
            "Department",
            handleCreateSchoolChilds,
          ),
          createOption(
            2,
            Loc.currentLang.menu.class,
            "Class",
            handleCreateSchoolChilds,
          ),
          createOption(
            3,
            Loc.currentLang.menu.group,
            "Group",
            handleCreateSchoolChilds,
          ),
          createOption(
            4,
            Loc.currentLang.menu.team,
            "Team",
            handleCreateSchoolChilds,
          ),
        ];
      }

      if (entity?.subType === "Department") {
        return [
          createOption(
            1,
            Loc.currentLang.menu.group,
            "Group",
            handleCreateSchoolChilds,
          ),
          createOption(
            2,
            Loc.currentLang.menu.class,
            "Class",
            handleCreateSchoolChilds,
          ),
          createOption(
            3,
            Loc.currentLang.menu.club,
            "Club",
            handleCreateSchoolChilds,
          ),
        ];
      }

      if (entity?.subType === "GradClass") {
        return [
          createOption(1, Loc.currentLang.menu.group, "Group", handleCreateOrg),
          createOption(2, Loc.currentLang.menu.team, "Team", handleCreateOrg),
          createOption(3, Loc.currentLang.menu.club, "Club", handleCreateOrg),
        ];
      }

      return [
        ...(isOrgType
          ? [
              createOption(
                1,
                Loc.currentLang.menu.team,
                "Team",
                handleCreateOrg,
              ),
            ]
          : []),
        ...(isOrgType
          ? [
              createOption(
                2,
                Loc.currentLang.menu.club,
                "Club",
                handleCreateOrg,
              ),
            ]
          : []),
        ...(entity?.type === "Organization"
          ? [
              createOption(
                3,
                Loc.currentLang.menu.organization,
                "Organization",
                handleCreateOrg,
              ),
            ]
          : []),
        ...(isOrgType
          ? [
              createOption(
                4,
                Loc.currentLang.menu.group,
                "Group",
                handleCreateOrg,
              ),
            ]
          : []),
      ];
    }

    if (tab === "Events") {
      return [
        ...(entity?.type === "PlayerOrg" && entity?.subType !== "Term"
          ? [
              createEventOption(1, Loc.currentLang.menu.practice, "Practice"),
              createEventOption(2, Loc.currentLang.menu.gamesTxt, "Game"),
            ]
          : []),
        createEventOption(3, Loc.currentLang.menu.socialText, "Social"),
        createEventOption(4, Loc.currentLang.menu.meeting, "Meeting"),
      ];
    }

    return [];
  };

  useEffect(() => {
    setHeaderText(getHeaderText());
    setHelpText(getHelpText());
    setDataList(getDataList());
    setDropdownValues(getDropdownValues());
  }, [entity, tab]);

  /* -------------------------------- Render -------------------------------- */

  const PariticipantFilter = ({ statusKey, type, setType, name, length }) => {
    return (
      <Button
        borderRadius={"19px"}
        height={"36px"}
        paddingLeft={"24px"}
        paddingRight={"24px"}
        bgColor={type === statusKey ? "#2FA3BE" : ""}
        onPress={() => {
          setType(statusKey);
        }}
      >
        <HStack space={1}>
          <Text
            color={type === statusKey ? "white" : "rgba(0,0,0,0.6)"}
            fontWeight={400}
            fontSize={"16px"}
          >
            {name}
          </Text>
          <Text
            color={type === statusKey ? "white" : "rgba(0,0,0,0.6)"}
            fontWeight={400}
            fontSize={"16px"}
          >
            ({length})
          </Text>
        </HStack>
      </Button>
    );
  };

  return (
    <>
      <Box
        minHeight="340px"
        pt="10px"
        borderRadius={5}
        bgColor="AVColor.white"
        shadow={4}
        flex={1}
        mb={3}
      >
        {/* HEADER */}
        <VStack>
          <HStack justifyContent="space-between" alignItems="center">
            <Text
              fontSize="22px"
              fontWeight="500"
              color="AVColor.primary"
              py="12px"
              ml="15px"
            >
              {headerText}
            </Text>

            <HStack alignItems="center" space={3} pr={2}>
              {/* Help Icon */}
              {(dataList?.length > 0 || allEventData?.length > 0) &&
                helpText?.trim().length > 0 && (
                  <Tooltip label={helpText} w={300}>
                    <Box
                      width="36px"
                      height="36px"
                      alignItems="center"
                      justifyContent="center"
                      bgColor="gray.100"
                      rounded="full"
                      shadow={1}
                    >
                      <img src={helping} width="17" height="17" />
                    </Box>
                  </Tooltip>
                )}

              {/* Edit Icon */}
              {isAdminView && tab === "Staff" && (
                <Tooltip label={Loc.currentLang.menu.editRoles} openDelay={500}>
                  <Pressable
                    width="36px"
                    height="36px"
                    bg="gray.100"
                    _hover={{ bgColor: "gray.50" }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    rounded="full"
                    shadow={1}
                    p={0}
                    onPress={() => {
                      navigate(
                        `/accountsettings/${entity?.id}/${entity?.region}`,
                        {
                          state: {
                            page: window.location.pathname,
                            Entity: entity,
                            isEdit: true,
                          },
                        },
                      );
                    }}
                  >
                    <EditIcon size="20px" />
                  </Pressable>
                </Tooltip>
              )}

              {/* Group Chat Icon */}
              {(tab === "Friends" ||
                tab === "Members" ||
                tab === "Participants" ||
                tab ===
                  "Staff") /* || tab === "Guardians" || tab === "Dependent"*/ &&
                !(entity?.type === "SchoolYear" && isAdminView) &&
                dataList?.length > 0 &&
                (tab !== "Participants" ||
                  isOngoingOrFuture ||
                  checkConvoExitorNot?.("N")) && (
                  <Offline>
                    {({ isOffline }) => (
                      <Button
                        isDisabled={
                          isOffline ||
                          (loadingAction?.type === "api" && loadingAction?.load)
                        }
                        width="36px"
                        height="36px"
                        p={0}
                        rounded="full"
                        bg={
                          loadingAction?.type === "api" && loadingAction?.load
                            ? "#32AE78"
                            : "gray.100"
                        }
                        _hover={{ bgColor: "gray.50" }}
                        shadow={1}
                        isLoading={
                          loadingAction?.type === "api" && loadingAction?.load
                        }
                        onPress={async () => {
                          setLoadingAction({
                            type: "api",
                            id: entity?.id ?? "",
                            load: true,
                          });
                          try {
                            await handleGroupChat?.(createConvoKey ?? "M");
                          } finally {
                            setLoadingAction(null);
                          }
                        }}
                      >
                        {
                          <GroupChatIcon
                            size={23}
                            color={"rgba(0, 0, 0, 0.5)"}
                          />
                        }
                      </Button>
                    )}
                  </Offline>
                )}

              {/* Add Icon */}
              {(tab === "Huddles" ||
                (tab === "Season" && entity?.type !== "School")) &&
                isAdminView && (
                  <Offline>
                    {({ isOffline }) => (
                      <Button
                        isDisabled={isOffline || isCreate}
                        width="36px"
                        height="36px"
                        bg="gray.100"
                        _hover={{ bgColor: "gray.50" }}
                        rounded="full"
                        shadow={1}
                        p={0}
                        onPress={() => setShowAddChildPopup(true)}
                      >
                        <AddIcon size="20px" color="#32AE78" />
                      </Button>
                    )}
                  </Offline>
                )}

              {(tab === "GradClass" ||
                tab === "Group" ||
                tab === "Friends" ||
                tab === "Guardians" ||
                tab === "Resources" ||
                tab === "Participants" ||
                tab === "Members" ||
                tab === "Staff") &&
                //entity?.subType !== "GradClass" &&
                ((tab !== "Resources" && tab !== "Participants") ||
                  isOngoingOrFuture) &&
                isAdminView && (
                  <Box ref={menuRefs ?? menuRef}>
                    <Offline>
                      {({ isOffline }) => (
                        <Button
                          ref={tab === "Members" ? addUserBtnRef : undefined}
                          isDisabled={isOffline}
                          width="36px"
                          height="36px"
                          bg="gray.100"
                          rounded="full"
                          shadow={1}
                          p={0}
                          _hover={{ bgColor: "gray.50" }}
                          onPress={() => {
                            if (tab === "Resources" || tab === "Participants") {
                              if (
                                (entity?.seriesEvents?.length ?? 0) > 1 &&
                                eventSeriesId
                              ) {
                                setIsShowEditOccurence?.(
                                  isOngoingOrFuture ?? false,
                                );
                                setIsShowEditEntireSeries?.(
                                  (isOngoingOrFuture ?? false) ||
                                    (isEntireSeriesAvailable ?? false),
                                );
                              } else {
                                if (tab === "Resources")
                                  setShowAddEditResourcePopup(
                                    !showAddEditResourcePopup,
                                  );
                                else handleProfileType?.("Participant");
                              }
                            } else {
                              if (
                                entity?.type === "School" &&
                                tab !== "Members" &&
                                tab !== "GradClass" &&
                                tab !== "Staff"
                              ) {
                                handleCreateSchoolChilds?.("Years");
                              } else if (
                                tab === "Friends" ||
                                tab === "Members"
                              ) {
                                handleProfileType?.("Member");
                              } else if (tab === "Staff") {
                                handleProfileType?.("Staff");
                              } else if (tab === "Guardians") {
                                handleProfileType?.("Guardians");
                              } else if (tab === "GradClass") {
                                entity?.type === "SchoolYear"
                                  ? setShowAddGradClassPopup(
                                      !showAddGradClassPopup,
                                    )
                                  : handleCreateSchoolChilds?.("GradClass");
                              } else {
                                handleCreateOrg?.("Group");
                              }
                            }
                          }}
                        >
                          <AddIcon size="20px" color="#32AE78" />
                        </Button>
                      )}
                    </Offline>

                    {(tab === "Resources" || tab === "Participants") &&
                      (isShowEditOccurence || isShowEditEntireSeries) && (
                        <Box
                          position="absolute"
                          top="44px"
                          right={0}
                          bg="gray.100"
                          rounded="md"
                          shadow={4}
                          width="150px"
                        >
                          {isShowEditOccurence && (
                            <Pressable
                              px={4}
                              py={2}
                              _hover={{ bgColor: "gray.50" }}
                              onPress={() => {
                                setIsEditEntireSeries?.(false);
                                setIsShowEditOccurence?.(false);
                                setIsShowEditEntireSeries?.(false);
                                if (tab === "Resources")
                                  setShowAddEditResourcePopup(true);
                                else handleProfileType?.("Participant");
                              }}
                            >
                              <Text>{Loc.currentLang.menu.thisOccurrence}</Text>
                            </Pressable>
                          )}

                          {isShowEditEntireSeries && (
                            <>
                              <Divider my={2} zIndex={-3} />
                              <Pressable
                                px={4}
                                py={2}
                                _hover={{ bgColor: "gray.50" }}
                                onPress={() => {
                                  setIsEditEntireSeries?.(true);
                                  setIsShowEditOccurence?.(false);
                                  setIsShowEditEntireSeries?.(false);
                                  if (tab === "Resources")
                                    setShowAddEditResourcePopup(true);
                                  else handleProfileType?.("Participant");
                                }}
                              >
                                <Text>{Loc.currentLang.menu.entireSeries}</Text>
                              </Pressable>
                            </>
                          )}
                        </Box>
                      )}
                  </Box>
                )}

              {tab === "Events" && isCalendarView && (
                <FormatListBulletedIcon
                  style={{ color: "#00A7BC" }}
                  onClick={() => setIsCalenderView?.(false)}
                  cursor="pointer"
                />
              )}

              {tab === "Events" && !isCalendarView && (
                <CalendarIcon
                  style={{ color: "#00A7BC" }}
                  onClick={() => setIsCalenderView?.(true)}
                  cursor="pointer"
                />
              )}

              {/* Dropdown */}
              {(tab === "Group" ||
                tab === "Organization" ||
                tab === "Events") &&
                dropdownValues?.length > 0 &&
                isAdminView && (
                  <AVComDropdonwn dropdownValues={dropdownValues} />
                )}

              {/* More (:) */}
              {(tab === "Huddles" ||
                tab === "Pet" ||
                tab === "Dependent" ||
                tab === "Group" ||
                tab === "Organization") &&
                /*&& entity?.type !== "School"*/
                isAdminView && (
                  <Box ref={menuRefs ?? menuRef}>
                    <Pressable
                      width="36px"
                      height="36px"
                      alignItems="center"
                      justifyContent="center"
                      bg="gray.100"
                      _hover={{ bgColor: "gray.50" }}
                      rounded="full"
                      shadow={1}
                      onPress={() => setIsMoreHeaderOpen(!isMoreHeaderOpen)}
                    >
                      <MoreHorizontalIcon
                        size="md"
                        color="#000"
                        style={{ transform: [{ rotate: "90deg" }] }}
                      />
                    </Pressable>

                    {isMoreHeaderOpen && (
                      <Box
                        position="absolute"
                        top="44px"
                        right={0}
                        bg="gray.100"
                        rounded="md"
                        shadow={4}
                        width={
                          tab === "Dependent" || tab === "Huddles"
                            ? "150px"
                            : "100px"
                        }
                      >
                        <Pressable
                          px={4}
                          py={2}
                          _hover={{ bgColor: "gray.50" }}
                          onPress={() => {
                            if (tab === "Huddles") {
                              setShowDeletedHuddles(false);
                              setDataList(getDataList(false));
                              setIsMoreHeaderOpen(!isMoreHeaderOpen);
                            } else {
                              handleProfileType?.(
                                tab === "Organization" &&
                                  entity?.type === "School"
                                  ? "Teams"
                                  : tab,
                              );
                            }
                          }}
                        >
                          <Text>
                            {tab === "Pet"
                              ? Loc.currentLang.menu.addPet
                              : tab === "Dependent"
                                ? Loc.currentLang.menu.addDependents
                                : tab === "Huddles"
                                  ? Loc.currentLang.menu.huddless
                                  : Loc.currentLang.menu.add}
                          </Text>
                        </Pressable>

                        {(tab === "Pet" ||
                          tab === "Dependent" ||
                          tab === "Huddles") && (
                          <>
                            <Divider my={2} zIndex={-3} />
                            <Pressable
                              px={4}
                              py={2}
                              _hover={{ bgColor: "gray.50" }}
                              onPress={() => {
                                if (tab === "Huddles") {
                                  setShowDeletedHuddles(true);
                                  setDataList(getDataList(true));
                                  setIsMoreHeaderOpen(!isMoreHeaderOpen);
                                } else {
                                  handleCreateOrg?.(tab);
                                }
                              }}
                            >
                              <Text>
                                {tab === "Pet"
                                  ? Loc.currentLang.menu.createPet
                                  : tab === "Dependent"
                                    ? Loc.currentLang.menu.createDependents
                                    : Loc.currentLang.huddles.deletedHuddles}
                              </Text>
                            </Pressable>
                          </>
                        )}
                      </Box>
                    )}
                  </Box>
                )}
            </HStack>
          </HStack>
        </VStack>

        <Divider my={2} zIndex={-3} />

        {/* CARD LIST */}
        {tab === "Events" ? (
          isLoadingEvent ? (
            <HStack space={2} justifyContent="center">
              <Spinner accessibilityLabel="Loading posts" />
              <Heading color="primary.500" fontSize="md">
                {Loc.currentLang.menu.loading}
              </Heading>
            </HStack>
          ) : (
            <HStack
              flexWrap="wrap"
              alignItems="stretch"
              justifyContent="flex-start"
              px={3}
              py={2}
              space={3}
              zIndex={-3}
            >
              {isCalendarView && (
                <AVCalendarView
                  data={allEventData?.filter((x) => x.status !== "No")}
                  eventType={Loc.currentLang.menu.current}
                />
              )}

              {!isCalendarView && allEventData?.length > 0 && (
                <EntityEvents entity={entity} allEventData={allEventData} />
              )}

              {allEventData?.length === 0 && !isCalendarView && (
                <HStack width="100%" space={2}>
                  <img src={inform} width="20" height="20" />
                  <Text
                    fontSize={"16px"}
                    fontWeight="400"
                    numberOfLines={4}
                    ellipsizeMode={"tail"}
                  >
                    {helpText}
                  </Text>
                </HStack>
              )}
            </HStack>
          )
        ) : tab === "Resources" ? (
          <ScrollView maxH="320px" zIndex={-3}>
            <VStack px={4} py={3} space={3}>
              {dataList?.length > 0 ? (
                dataList?.map((item: any) => (
                  <HStack
                    key={item?.resourceId}
                    alignItems="center"
                    justifyContent="space-between"
                    bg="gray.100"
                    px={4}
                    py={3}
                    borderRadius="8px"
                  >
                    {/* Item Name */}
                    <Text width="40%" fontWeight="500" isTruncated>
                      {item?.resource}
                    </Text>

                    {/* Quantity */}
                    <Text width="10%" textAlign="center">
                      {item?.quantity}
                    </Text>

                    {/* Assigned Participant */}
                    <HStack width="35%" alignItems="center" space={2}>
                      {item?.id && (
                        <Pressable
                          onPress={() =>
                            navigate(`/profile/${item?.id}/${item?.region}`, {
                              state: { user: item },
                            })
                          }
                        >
                          <HStack alignItems="center" space={2}>
                            <EntityProfilePic
                              width={28}
                              height={28}
                              link={
                                entityDataList?.find(
                                  (x: any) => x?.id === item?.id,
                                )
                                  ? AV.AVEntity.getLink(
                                      entityDataList?.find(
                                        (x: any) => x?.id === item?.id,
                                      ),
                                    )
                                  : item
                              }
                            />
                            <Text fontWeight="400">
                              {currentUser?.id !== item?.id
                                ? item?.title
                                : Loc.currentLang.menu.you}
                            </Text>
                          </HStack>
                        </Pressable>
                      )}
                    </HStack>

                    {/* Actions */}
                    <HStack width="15%" justifyContent="flex-end" space={4}>
                      {isAdminView && isOngoingOrFuture && (
                        <>
                          <Pressable
                            onPress={() => {
                              setResourceEditItem(item);
                              setResourceDesc(item?.resource);
                              setResourceQty(String(item?.quantity));
                              setResourceNote(item?.notes);

                              setResourceAssignTo({
                                id: item?.id,
                                pk: item?.pk,
                                region: item?.region,
                                type: item?.type,
                                thumb: item?.thumb,
                                title: item?.title,
                                background: item?.background,
                              });

                              setShowAddEditResourcePopup(true);
                            }}
                          >
                            <EditIcon size={18} />
                          </Pressable>

                          <Pressable onPress={() => handleRemoveGroup?.(item)}>
                            <DeleteIcon size={18} />
                          </Pressable>
                        </>
                      )}

                      {(!isAdminView || !isOngoingOrFuture) && (
                        <Pressable
                          onPress={() => {
                            setResourceEditItem(item);
                            setResourceDesc(item?.resource);
                            setResourceQty(String(item?.quantity));
                            setResourceNote(item?.notes);

                            setResourceAssignTo({
                              id: item?.id,
                              pk: item?.pk,
                              region: item?.region,
                              type: item?.type,
                              thumb: item?.thumb,
                              title: item?.title,
                              background: item?.background,
                            });

                            setShowAddEditResourcePopup(true);
                          }}
                        >
                          <ViewIcon size={18} />
                        </Pressable>
                      )}
                    </HStack>
                  </HStack>
                ))
              ) : (
                <HStack width="100%" space={2}>
                  <img src={inform} width="20" height="20" />
                  <Text fontSize="16px" fontWeight="400">
                    {helpText}
                  </Text>
                </HStack>
              )}
            </VStack>
          </ScrollView>
        ) : tab === "Participants" ? (
          <VStack p={1} zIndex={-3}>
            <div className="custom-scrollbar">
              <HStack
                marginY={"24px"}
                overflowY={isMobile ? "auto" : undefined}
                backgroundColor={"rgba(0,0,0,0.05)"}
                borderRadius={"18px"}
                marginLeft={"24px"}
                height={"36px"}
                width={isMobile ? "" : "500px"}
              >
                <PariticipantFilter
                  statusKey="All"
                  type={participantStatus}
                  setType={setAllStatus}
                  name={Loc.currentLang.menu.all}
                  length={dataList?.length}
                />
                <PariticipantFilter
                  statusKey="RSVP"
                  type={participantStatus}
                  setType={setRsvpStatus}
                  name={Loc.currentLang.menu.rsvp}
                  length={
                    dataList?.filter((x) => x?.status === undefined)?.length
                  }
                />
                <PariticipantFilter
                  statusKey="Yes"
                  type={participantStatus}
                  setType={setYesStatus}
                  name={Loc.currentLang.menu.yes}
                  length={dataList?.filter((x) => x.status === "Yes")?.length}
                />
                <PariticipantFilter
                  statusKey="No"
                  type={participantStatus}
                  setType={setNoStatus}
                  name={Loc.currentLang.menu.no}
                  length={dataList?.filter((x) => x.status === "No")?.length}
                />
                <PariticipantFilter
                  statusKey="Maybe"
                  type={participantStatus}
                  setType={setMaybeStatus}
                  name={Loc.currentLang.menu.maybe}
                  length={dataList?.filter((x) => x.status === "Maybe")?.length}
                />
              </HStack>
            </div>

            {filteredParticipants?.length > 0 ? (
              <HStack alignItems="center" px={5} flexWrap="nowrap" space={2}>
                <HStack flexWrap="wrap" maxWidth="100%" alignSelf="flex-start">
                  {filteredParticipants.map((item: any, i: number) => {
                    const cacheItem = entityDataList?.find(
                      (x) => x?.id === item?.id,
                    );

                    let finalItem = item;

                    if (cacheItem || currentUser?.id === item?.id) {
                      finalItem =
                        currentUser?.id === item?.id
                          ? AV.AVEntity.getLink(currentUser)
                          : AV.AVEntity.getLink(cacheItem);
                    }

                    return (
                      <Box
                        key={finalItem.id}
                        position="relative"
                        bgColor="#fff"
                        borderWidth="1px"
                        margin={4}
                        borderColor="#e7ebe5"
                        width="170px"
                        height="160px"
                        rounded="lg"
                      >
                        {/* Chat Icon */}
                        {currentUser?.id !== finalItem?.id && (
                          <Offline>
                            {({ isOffline }) => (
                              <Pressable
                                position="absolute"
                                top="10px"
                                left="10px"
                                zIndex={10}
                                isDisabled={isOffline}
                                onPress={async () => {
                                  setLoadingAction({
                                    type: "chat",
                                    id: item.id,
                                    load: true,
                                  });
                                  try {
                                    await handleChat?.(finalItem);
                                  } finally {
                                    setLoadingAction(null);
                                  }
                                }}
                              >
                                {loadingAction?.type === "chat" &&
                                loadingAction?.id === finalItem.id ? (
                                  <div className="loading" />
                                ) : (
                                  <GroupChatIcon
                                    size={23}
                                    color="rgba(0,0,0,0.5)"
                                  />
                                )}
                              </Pressable>
                            )}
                          </Offline>
                        )}

                        <Pressable
                          p={2}
                          borderRadius={8}
                          height="100%"
                          _hover={{ bg: "AVColor.hovercolor2" }}
                          onPress={() => handleItemNavigation(item)}
                        >
                          {/* Remove Icon */}
                          {isAdminView &&
                            isOngoingOrFuture &&
                            filteredParticipants?.length !== 1 && (
                              <Pressable
                                padding={1.5}
                                rounded="full"
                                position="absolute"
                                right={-10}
                                top={-10}
                                backgroundColor="AVColor.buttonBg"
                                _hover={{
                                  backgroundColor: "AVColor.hovercolor2",
                                }}
                                onPress={() => handleRemoveGroup?.(finalItem)}
                              >
                                <CloseIcon
                                  size="12px"
                                  color="AVColor.secondaryText"
                                />
                              </Pressable>
                            )}

                          <VStack alignItems="center" padding={2}>
                            {finalItem?.thumb || finalItem?.linkPic ? (
                              <Image
                                source={{ uri: AV.Media.getThumb(finalItem) }}
                                borderRadius="full"
                                width="70px"
                                height="70px"
                              />
                            ) : (
                              <EntityProfilePic
                                height="70"
                                width="70"
                                link={finalItem as AV.ILink}
                              />
                            )}

                            <Text
                              mt={2}
                              width="100px"
                              numberOfLines={1}
                              textAlign="center"
                            >
                              {finalItem.title}
                            </Text>
                          </VStack>
                        </Pressable>
                      </Box>
                    );
                  })}
                </HStack>
              </HStack>
            ) : (
              <HStack width="100%" space={2}>
                <img src={inform} width="20" height="20" />
                <Text fontSize="16px" fontWeight="400">
                  {helpText}
                </Text>
              </HStack>
            )}
          </VStack>
        ) : (
          <HStack
            flexWrap="wrap"
            alignItems="stretch"
            justifyContent="flex-start"
            left={2}
            px={tab === "Staff" ? 6 : 3}
            py={2}
            space={tab === "Staff" ? 10 : 3}
            zIndex={-3}
          >
            {dataList.length === 0 ? (
              <HStack width="100%" space={2}>
                <img src={inform} width="20" height="20" />
                <Text
                  fontSize={"16px"}
                  fontWeight="400"
                  numberOfLines={4}
                  ellipsizeMode={"tail"}
                >
                  {helpText}
                </Text>
              </HStack>
            ) : (
              [...new Map(dataList.map((i) => [i.id, i])).values()].map(
                (item: any) => {
                  if (tab !== "Staff") {
                    const cacheItem = entityDataList?.find(
                      (x) => x?.id === item?.id,
                    );

                    if (cacheItem || currentUser?.id === item?.id) {
                      item =
                        currentUser?.id === item?.id
                          ? AV.AVEntity.getLink(currentUser)
                          : AV.AVEntity.getLink(cacheItem);
                    }
                  }

                  return (
                    <Box
                      key={item.id}
                      ref={onboardingFlow === "season" ? itemRef : null}
                      position="relative"
                      width={isMobile ? "48%" : tab === "Staff" ? "28%" : "23%"}
                      mb="20px"
                      minHeight={"200px"}
                    >
                      {/* Chat Icon */}
                      {(tab === "Friends" ||
                        tab === "Guardians" ||
                        tab === "Dependent" ||
                        tab === "Members" ||
                        tab === "Staff") &&
                        item?.type === "Person" &&
                        entity?.id !== item?.id &&
                        currentUser?.id !== item?.id && (
                          <Offline>
                            {({ isOffline }) => (
                              <Pressable
                                isDisabled={isOffline}
                                zIndex={10}
                                position="absolute"
                                top="25px"
                                left="16px"
                                onPress={async () => {
                                  setLoadingAction({
                                    type: "chat",
                                    id: item.id,
                                    load: true,
                                  });
                                  try {
                                    await handleChat?.(item);
                                  } finally {
                                    setLoadingAction(null);
                                  }
                                }}
                              >
                                {loadingAction?.type === "chat" &&
                                loadingAction?.id === item.id ? (
                                  <div className="loading" />
                                ) : (
                                  <GroupChatIcon
                                    size={23}
                                    color="rgba(0, 0, 0, 0.5)"
                                  />
                                )}
                              </Pressable>
                            )}
                          </Offline>
                        )}

                      {/* Remove Icon */}
                      {(tab === "GradClass" ||
                        tab === "Group" ||
                        tab === "Organization" ||
                        tab === "Pet" ||
                        tab === "Friends" ||
                        tab === "Guardians" ||
                        tab === "Dependent") &&
                        entity?.subType !== "Alumni" &&
                        isAdminView && (
                          <Pressable
                            position="absolute"
                            right={-6}
                            top={-6}
                            zIndex={10}
                            p={1.5}
                            rounded="full"
                            bg="AVColor.buttonBg"
                            _hover={{ bg: "AVColor.hovercolor2" }}
                            onPress={() => {
                              if (
                                tab === "Group" ||
                                tab === "Pet" ||
                                tab === "Friends" ||
                                tab === "Guardians" ||
                                tab === "Dependent"
                              ) {
                                entity?.type === "School"
                                  ? handleConfirmRemoveSchoolOrgs?.(
                                      "RemoveSchoolSeason",
                                      item,
                                    )
                                  : handleRemoveGroup?.(item);
                              } else if (tab === "GradClass") {
                                handleConfirmRemoveSchoolOrgs?.(
                                  entity?.type === "SchoolYear"
                                    ? "RemoveSchoolGradClass"
                                    : "RemoveSchoolSeason",
                                  item,
                                );
                              } else if (tab === "Organization") {
                                entity?.type === "School"
                                  ? handleConfirmRemoveSchoolOrgs?.(
                                      "RemoveSchoolSeason",
                                      item,
                                    )
                                  : handleRemove?.("Season", item);
                              }
                            }}
                          >
                            <CloseIcon
                              size="12px"
                              color="AVColor.secondaryText"
                            />
                          </Pressable>
                        )}

                      {/* Right-side More (:) */}
                      {tab === "Members" && isAdminView && (
                        <Box
                          ref={menuRefs ?? menuRef}
                          data-list-menu="true"
                          position="absolute"
                          top="20px"
                          right={0}
                          zIndex={20}
                        >
                          <Pressable
                            data-list-menu="true"
                            width="32px"
                            height="32px"
                            alignItems="center"
                            justifyContent="center"
                            right={0}
                            onPress={(e) => {
                              e.stopPropagation();
                              setIsMoreListOpen((prev) => {
                                const isOpen = prev[item.id];
                                return isOpen ? {} : { [item.id]: true };
                              });
                            }}
                          >
                            {loadingAction?.type === "menu" &&
                            loadingAction?.id === item.id ? (
                              <div className="loading" />
                            ) : (
                              <MoreHorizontalIcon
                                size="md"
                                color="#000"
                                style={{ transform: [{ rotate: "90deg" }] }}
                              />
                            )}
                          </Pressable>

                          {isMoreListOpen?.[item.id] && (
                            <Box
                              position="absolute"
                              top="36px"
                              left={-100}
                              bg="gray.100"
                              rounded="md"
                              shadow={6}
                              minW="120px"
                              zIndex={999}
                            >
                              {/* Silence / Unsilence */}
                              <Pressable
                                px={4}
                                py={2}
                                justifyContent="flex-start"
                                _hover={{ bgColor: "gray.50" }}
                                onPress={() => handleConfirmToggleSilence(item)}
                              >
                                <Text>
                                  {currentUser?.silenced?.some(
                                    (x) => x?.id === item?.id,
                                  )
                                    ? Loc.currentLang.menu.unSilence
                                    : Loc.currentLang.menu.silence}
                                </Text>
                              </Pressable>

                              <Divider />

                              {/* Delete */}
                              <Pressable
                                px={4}
                                py={2}
                                justifyContent="flex-start"
                                _hover={{ bgColor: "gray.50" }}
                                onPress={async () => {
                                  await handleRemoveGroup?.(item);
                                  setIsMoreListOpen((prev) => ({
                                    ...prev,
                                    [item.id]: false,
                                  }));
                                }}
                              >
                                <Text>{Loc.currentLang.menu.delete}</Text>
                              </Pressable>

                              {/* Edit */}
                              {/*{tab === "Staff" && (*/}
                              {/*  <>*/}
                              {/*    <Divider />*/}

                              {/*    <Pressable*/}
                              {/*      px={4}*/}
                              {/*      py={2}*/}
                              {/*      justifyContent="flex-start"*/}
                              {/*      _hover={{ bgColor: "gray.50" }}*/}
                              {/*      onPress={() => {*/}
                              {/*        //setShowEditStaffPopup(true);*/}
                              {/*        setIsMoreListOpen((prev) => ({*/}
                              {/*          ...prev,*/}
                              {/*          [item.id]: false,*/}
                              {/*        }));*/}
                              {/*      }}*/}
                              {/*    >*/}
                              {/*      <Text>{Loc.currentLang.menu.edit}</Text>*/}
                              {/*    </Pressable>*/}
                              {/*  </>*/}
                              {/*)}*/}
                            </Box>
                          )}
                        </Box>
                      )}

                      {/* Card */}
                      <Pressable
                        key={item.id}
                        position="relative"
                        bg="white"
                        shadow={1}
                        rounded="lg"
                        borderWidth="1px"
                        borderColor="gray.400"
                        minHeight={tab === "Staff" ? "240px" : "200px"}
                        p={5}
                        _hover={{ bg: "gray.100" }}
                        onPress={() => handleItemNavigation(item)}
                      >
                        <VStack
                          alignItems="center"
                          justifyContent="flex-start"
                          pt={tab === "Staff" ? 0 : 2}
                        >
                          {/* Logo */}
                          <Box
                            w="70px"
                            h="70px"
                            borderRadius="full"
                            bg="gray.100"
                            alignItems="center"
                            justifyContent="center"
                            mb={4}
                          >
                            {tab === "Staff" &&
                            (item?.thumb || item?.linkPic) ? (
                              <Image
                                source={{
                                  uri: item?.linkPic
                                    ? AV.Media.getURL(item?.linkPic)
                                    : AV.Media.getThumb(item as AV.ILink),
                                }}
                                borderRadius="full"
                                width="100%"
                                height="100%"
                              />
                            ) : (
                              <EntityProfilePic
                                width={70}
                                height={70}
                                link={item}
                              />
                            )}
                          </Box>

                          {/* Item Name */}
                          <Tooltip
                            label={
                              tab === "Huddles"
                                ? item?.title
                                : (item?.data ?? item?.title)
                            }
                            openDelay={500}
                          >
                            <Pressable
                              onPress={() => handleItemNavigation(item)}
                            >
                              <Text
                                mt={tab === "Staff" ? 0 : 2}
                                width="120px"
                                numberOfLines={2}
                                textAlign="center"
                              >
                                {tab === "Huddles"
                                  ? item?.title
                                  : (item?.data ?? item?.title)}
                              </Text>
                            </Pressable>
                          </Tooltip>

                          {/* Staff Role */}
                          {tab === "Staff" && (
                            <VStack
                              mt={2}
                              alignItems="center"
                              space={1}
                              width="100%"
                            >
                              {/* Role Badge */}
                              <Box>
                                <Text
                                  fontSize="13px"
                                  fontWeight="600"
                                  px={3}
                                  py={1}
                                  rounded="full"
                                  bg={item?.role?.name ? "gray.200" : "blue.50"}
                                  color={
                                    item?.role?.name ? "gray.700" : "#00A7BC"
                                  }
                                  textAlign="center"
                                >
                                  {item?.role?.name ?? "Assign Role"}
                                </Text>
                              </Box>

                              {/* Phone */}
                              {item?.phone && (
                                <Text
                                  fontSize="12px"
                                  color="#00A7BC"
                                  numberOfLines={1}
                                  width="100%"
                                  textAlign="center"
                                  isTruncated
                                >
                                  {item?.phone}
                                </Text>
                              )}

                              {/* Email */}
                              {item?.email && (
                                <Pressable
                                  width="100%"
                                  onPress={() =>
                                    (window.location.href = `mailto:${item?.email}`)
                                  }
                                >
                                  <Text
                                    fontSize="13px"
                                    color="#00A7BC"
                                    numberOfLines={1}
                                    width="100%"
                                    textAlign="center"
                                    textDecorationLine="underline"
                                    isTruncated
                                  >
                                    {item?.email}
                                  </Text>
                                </Pressable>
                              )}
                            </VStack>
                          )}
                        </VStack>
                      </Pressable>

                      {/* Edit & Delete Actions */}
                      {isAdminView && tab === "Staff" && (
                        <HStack
                          position="absolute"
                          bottom="0"
                          left="0"
                          right="0"
                          justifyContent="center"
                        >
                          <HStack px={4} py={2} space={5} alignItems="center">
                            {/* Edit */}
                            <Pressable
                              _hover={{ opacity: 0.7 }}
                              onPress={() => {
                                setEditStaffItem(item);
                                setStaffPhone(item?.phone);
                                setStaffEmail(item?.email);
                                setStaffRole(item?.role?.name);
                                setShowEditStaffPopup(true);
                              }}
                            >
                              <EditIcon size={18} />
                            </Pressable>

                            {/* Delete */}
                            {item?.role?.name !== "Owner" &&
                              dataList?.length !== 1 &&
                              currentUser?.id !== item?.id && (
                                <>
                                  <Divider
                                    orientation="vertical"
                                    height="18px"
                                  />
                                  <Pressable
                                    _hover={{ opacity: 0.7 }}
                                    onPress={() => handleRemoveGroup?.(item)}
                                  >
                                    <DeleteIcon size={18} />
                                  </Pressable>
                                </>
                              )}
                          </HStack>
                        </HStack>
                      )}
                    </Box>
                  );
                },
              )
            )}
          </HStack>
        )}
      </Box>

      {/* ADD CHILD POPUP */}
      {showAddChildPopup && (
        <Box
          position="fixed"
          top={0}
          left={0}
          right={0}
          bottom={0}
          bgColor="AVColor.overlay2"
          zIndex={99999}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Box
            bg="white"
            width={isMobile ? "90%" : "520px"}
            borderRadius="12px"
            overflow="hidden"
            shadow={5}
          >
            {/* ================= HEADER ================= */}
            <HStack
              justifyContent="space-between"
              alignItems="center"
              px={5}
              py={4}
              borderBottomWidth={1}
              borderColor="AVColor.grey"
            >
              <Text fontSize="20px" fontWeight="600">
                {tab === "Huddles"
                  ? Loc.currentLang.huddles.createHuddle
                  : entity?.subType === "Club"
                    ? Loc.currentLang.menu.addTerm
                    : entity?.type === "PlayerOrg"
                      ? Loc.currentLang.menu.addOrganization
                      : Loc.currentLang.menu.addSeason}
              </Text>

              <HStack space={3}>
                <Tooltip label={helpText} w={200} openDelay={100}>
                  <Box bg="AVColor.liteBg" p="8px" borderRadius="full">
                    <img src={helping} width="16" height="16" />
                  </Box>
                </Tooltip>

                <AVCancel
                  color={undefined}
                  size={undefined}
                  callback={() => {
                    setChildName("");
                    setChildDescription("");
                    setShowAddChildPopup(false);
                  }}
                />
              </HStack>
            </HStack>

            {/* ================= BODY ================= */}
            <Box px={5} py={4}>
              <AVInputtext
                type="text"
                label={
                  tab === "Huddles"
                    ? `${Loc.currentLang.huddles.huddleName} *`
                    : entity?.subType === "Club"
                      ? Loc.currentLang.menu.termName
                      : entity?.type === "PlayerOrg"
                        ? "Organization Name"
                        : Loc.currentLang.menu.seasonName
                }
                value={childName}
                onChange={(e) => setChildName(e.target.value)}
              />
            </Box>

            {tab === "Huddles" && (
              <Box px={5} py={4}>
                <AVInputtext
                  type="text"
                  label={Loc.currentLang.profile.description}
                  minRows={2}
                  multiline={true}
                  value={childDescription}
                  onChange={(e) => setChildDescription(e.target.value)}
                />
              </Box>
            )}

            {/* ================= FOOTER ================= */}
            <HStack
              justifyContent="flex-end"
              px={5}
              py={4}
              borderColor="AVColor.grey"
            >
              <Button
                width="160px"
                height="40px"
                borderRadius="full"
                backgroundColor="AVColor.primary"
                isDisabled={
                  (loadingAction?.type === "api" && loadingAction?.load) ||
                  !childName.trim()
                }
                isLoading={loadingAction?.type === "api" && loadingAction?.load}
                onPress={handleCreateChild}
              >
                <Text color="white" fontWeight="600">
                  {tab === "Huddles"
                    ? Loc.currentLang.menu.create
                    : Loc.currentLang.menu.add}
                </Text>
              </Button>
            </HStack>
          </Box>
        </Box>
      )}

      {/* EDIT STAFF POPUP */}
      {showEditStaffPopup && (
        <Box
          position="fixed"
          top={50}
          left={0}
          right={0}
          bottom={0}
          bgColor="AVColor.overlay2"
          zIndex={99999}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Box
            bg="white"
            width={isMobile ? "90%" : "700px"}
            borderRadius="16px"
            overflow="hidden"
            shadow={5}
          >
            {/* ================= HEADER ================= */}
            <HStack
              justifyContent="space-between"
              alignItems="center"
              px={6}
              py={4}
              borderBottomWidth={1}
              borderColor="AVColor.grey"
            >
              <Text fontSize="20px" fontWeight="600">
                {Loc.currentLang.menu.editStaffMember}
              </Text>

              <AVCancel
                color={undefined}
                size={undefined}
                callback={() => {
                  setStaffPhone("");
                  setStaffEmail("");
                  setShowEditStaffPopup(false);
                }}
              />
            </HStack>

            {/* ================= PROFILE SECTION ================= */}
            <VStack alignItems="center" py={6} space={3}>
              <Box position="relative">
                {/* Logo */}
                <Box
                  w="100px"
                  h="100px"
                  borderRadius="full"
                  bg="gray.100"
                  alignItems="center"
                  justifyContent="center"
                  mb={4}
                >
                  {editStaffItem?.thumb || editStaffItem?.linkPic ? (
                    <Image
                      source={{
                        uri: editStaffItem?.linkPic
                          ? AV.Media.getURL(editStaffItem?.linkPic)
                          : AV.Media.getThumb(editStaffItem as AV.ILink),
                      }}
                      borderRadius="full"
                      width="100%"
                      height="100%"
                    />
                  ) : (
                    <EntityProfilePic
                      width={100}
                      height={100}
                      link={editStaffItem as AV.ILink}
                    />
                  )}
                </Box>

                {/* Upload Button */}
                <Button
                  bgColor="AVColor.white"
                  position="absolute"
                  bottom={0}
                  right={-2}
                  p={1}
                  rounded="full"
                  shadow={2}
                  isLoading={
                    loadingAction?.type === "pic" && loadingAction?.load
                  }
                  _hover={{ bg: "AVColor.hovercolor" }}
                  _spinner={{ color: "AVColor.black" }}
                >
                  <Box {...getStaffProfilePicFile({ className: "dropzone" })}>
                    <input {...getStaffProfileInputProps()} />
                    <AddPhotoIcon size={18} />
                  </Box>
                </Button>
              </Box>

              <Text
                fontSize="22px"
                fontWeight="600"
                numberOfLines={1}
                textAlign="center"
                maxW="80%"
              >
                {editStaffItem?.title}
              </Text>
            </VStack>

            {/* ================= FORM SECTION ================= */}
            <VStack px={6} pb={6} space={5}>
              {/* Assign Role */}
              <FormControl fullWidth>
                <InputLabel id="role-select-label">
                  {Loc.currentLang.menu.assignRoleReq}
                </InputLabel>

                <Select
                  labelId="role-select-label"
                  id="role-select"
                  value={staffRole}
                  label={Loc.currentLang.menu.roles}
                  onChange={(e) => setStaffRole(e.target.value)}
                  MenuProps={{
                    PaperProps: {
                      style: { maxHeight: 300 },
                    },
                  }}
                >
                  {entity?.roles?.map((option) => (
                    <MenuItem key={option?.name} value={option?.name}>
                      {option?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Phone */}
              <AVInputtext
                type="text"
                label={Loc.currentLang.menu.phone}
                value={staffPhone}
                onChange={(e) => setStaffPhone(e.target.value)}
              />

              {/* Email */}
              <AVInputtext
                type="text"
                label={Loc.currentLang.menu.emailAddressNotReq}
                value={staffEmail}
                onChange={(e) => setStaffEmail(e.target.value)}
              />
            </VStack>

            {/* ================= FOOTER ================= */}
            <HStack justifyContent="flex-end" px={6} pb={6}>
              <Button
                width="160px"
                height="42px"
                borderRadius="full"
                backgroundColor="AVColor.primary"
                isLoading={loadingAction?.type === "api" && loadingAction?.load}
                onPress={() => {
                  handleEditStaff(editStaffItem);
                }}
              >
                <Text color="white" fontWeight="600">
                  {Loc.currentLang.menu.save}
                </Text>
              </Button>
            </HStack>
          </Box>
        </Box>
      )}

      {/* ADD/EDIT RESOURCE ITEM POPUP */}
      {showAddEditResourcePopup && (
        <Box
          position="fixed"
          top={50}
          left={0}
          right={0}
          bottom={0}
          bgColor="AVColor.overlay2"
          zIndex={99999}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Box
            bg="white"
            width={isMobile ? "90%" : "700px"}
            borderRadius="16px"
            overflow="hidden"
            shadow={5}
          >
            {/* ================= HEADER ================= */}
            <HStack
              justifyContent="space-between"
              alignItems="center"
              px={6}
              py={4}
              borderBottomWidth={1}
              borderColor="AVColor.grey"
            >
              <Text fontSize="20px" fontWeight="600">
                {!(isAdminView && isOngoingOrFuture)
                  ? Loc.currentLang.menu.viewItem
                  : resourceEditItem
                    ? Loc.currentLang.menu.editItem
                    : Loc.currentLang.menu.addItem}
              </Text>

              <HStack space={3}>
                <Tooltip label={helpText} w={200} openDelay={100}>
                  <Box bg="AVColor.liteBg" p="8px" borderRadius="full">
                    <img src={helping} width="16" height="16" />
                  </Box>
                </Tooltip>

                <AVCancel
                  color={undefined}
                  size={undefined}
                  callback={() => {
                    setResourceQty("1");
                    setResourceDesc("");
                    setResourceNote("");
                    setResourceAssignTo(undefined);
                    setResourceEditItem(undefined);
                    setShowAddEditResourcePopup(false);
                  }}
                />
              </HStack>
            </HStack>

            {/* ================= FORM SECTION ================= */}
            <VStack px={6} pt={4} pb={6} space={4}>
              {/* Resource Description */}
              <AVInputtext
                type="text"
                label={Loc.currentLang.menu.itemDescription}
                value={resourceDesc}
                onChange={(e) => setResourceDesc(e.target.value)}
                disabled={!(isAdminView && isOngoingOrFuture)}
              />

              {/* Resource Quantity */}
              <AVInputtext
                type="text"
                label={Loc.currentLang.menu.quantity}
                value={resourceQty}
                onChange={(e) => setResourceQty(e.target.value)}
                disabled={!(isAdminView && isOngoingOrFuture)}
              />

              {/* Assign To Participant */}
              <FormControl fullWidth>
                <InputLabel id="role-select-label">
                  {Loc.currentLang.menu.assignToTeamMember}
                </InputLabel>

                <Select
                  labelId="role-select-label"
                  id="role-select"
                  value={resourceAssignTo?.id ?? ""}
                  label={Loc.currentLang.menu.assignToTeamMember}
                  onChange={(e) => {
                    const selected = participantList?.find(
                      (x) => x.id === e.target.value,
                    );
                    setResourceAssignTo(selected);
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: { maxHeight: 300 },
                    },
                  }}
                  disabled={!(isAdminView && isOngoingOrFuture)}
                >
                  {participantList?.map((option) => (
                    <MenuItem key={option?.id} value={option?.id ?? ""}>
                      <HStack alignItems="center" space={2}>
                        <EntityProfilePic
                          width={28}
                          height={28}
                          link={option}
                        />
                        <Text>{option?.title}</Text>
                      </HStack>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Resource Note */}
              <AVInputtext
                type="text"
                label={Loc.currentLang.menu.additionalNote}
                maxLength={500}
                minRows={6}
                multiline={true}
                value={resourceNote}
                onChange={(e) => setResourceNote(e.target.value)}
                disabled={!(isAdminView && isOngoingOrFuture)}
              />
            </VStack>

            {/* ================= FOOTER ================= */}
            <HStack justifyContent="flex-end" px={6} pb={6}>
              {isAdminView && isOngoingOrFuture && (
                <Button
                  width="160px"
                  height="42px"
                  borderRadius="full"
                  backgroundColor="AVColor.primary"
                  isLoading={
                    loadingAction?.type === "api" && loadingAction?.load
                  }
                  isDisabled={
                    !resourceQty ||
                    Number(resourceQty) <= 0 ||
                    resourceDesc?.trim()?.length == 0
                  }
                  onPress={() => {
                    handleAddEditResource();
                  }}
                >
                  <Text color="white" fontWeight="600">
                    {resourceEditItem
                      ? Loc.currentLang.menu.update
                      : Loc.currentLang.menu.add}
                  </Text>
                </Button>
              )}
            </HStack>
          </Box>
        </Box>
      )}

      {/* ADD GRADCLASS POPUP */}
      {showAddGradClassPopup && (
        <AddGraduationClassPopup
          entity={entity}
          setEntity={setEntity}
          isOpen={showAddGradClassPopup}
          setSchoolGradClassList={setDataList}
          setSchoolYearGradClassList={setDataList}
          onClose={() => setShowAddGradClassPopup(false)}
        />
      )}

      {/* CONFIRMATION POPUP */}
      {isConfirm && (
        <AVConfirmationModal
          showconfirmationPopup={isConfirm}
          setshowconfirmationPopup={setIsConfirm}
          Confirmationtext={confirmationText}
          type={selectedType}
          item={undefined}
          function={handleToggleSilence}
          isLoader={false}
        />
      )}
    </>
  );
};

export default AVCardList;
